import { BonusStatus } from '../api-client';

export const bonusStatusUiItems = [
  { label: 'All', value: BonusStatus.Unknown },
  { label: 'Unapproved', value: BonusStatus.Unapproved },
  { label: 'Approved', value: BonusStatus.Approved },
  { label: 'Denied', value: BonusStatus.Denied },
  { label: 'Paid', value: BonusStatus.Paid }
];
